import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const procesContent =[
    {
       icon: "icon-24b",
       title: "Crear Cuenta",
       desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
       margin: "mb-40"
    },
    {
       icon: "icon-25b",
       title: "Elige Cualquier Servicio",
       desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
       margin: "mb-40"
    },
    {
       icon: "icon-26b",
       title: "Obtener Soluciones",
       desc: "Proporcionamos acceso interactivo a materiales de clase mundial para catalizadores.",
       margin: "mb-65"
    }
]

const BlockStylFive = () => {
    return (
        <Fragment>
            <div className="block-style-six">
                {procesContent.map((val,i)=>(
                    <div key={i} className={`process-box ${val.margin}`}>
                        <div className="img">
                            <img src={`assets/img/icon/${val.icon}.svg`} alt="icon"/>
                        </div>
                        <div className="text-wrapper">
                            <h3 className="sect-title-two">{val.title}</h3>
                            <p>{val.desc}</p>
                        </div>
                    </div>
                ))}
                <div className="text-md-start text-center">
                    <Link className="theme_btn" to="/services">Más Detalles</Link>
                </div>
            </div>
        </Fragment>
    )
}

export default BlockStylFive